import { useContext } from 'react'
import { DialogContext } from '../components/MotionDialog'

export const useDialogContext = () => useContext(DialogContext)